import * as ROUTES from '#client/constants/routes';

const sortMenuItems = (a, b) => (a.order < b.order ? -1 : 1);

const USER_MENU_CONFIG = [
  {
    order: 10,
    type: 'link',
    title: 'account settings',
    path: ROUTES.accountSettings,
    icon: {
      src: 'settings-outline.svg',
      alt: 'settings'
    }
  },
  {
    order: 20,
    type: 'link',
    title: 'billing',
    path: ROUTES.billing,
    icon: {
      src: 'credit-card-outline.svg',
      alt: 'payment'
    }
  },
  {
    order: 30,
    type: 'link',
    title: 'get help',
    path: ROUTES.help,
    icon: {
      src: 'question-mark-outline.svg',
      alt: 'help'
    }
  },
  {
    order: 40,
    type: 'divider'
  },
  {
    order: 50,
    type: 'link',
    title: 'log out',
    path: ROUTES.logout,
    icon: {
      src: 'logout-outline.svg',
      alt: 'logout'
    }
  }
];

export default USER_MENU_CONFIG.sort(sortMenuItems);
